export default __webpack_public_path__ + "static/media/nik.470f3357.png";